"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _primary = _interopRequireDefault(require("../img/primary.svg"));

var _error = _interopRequireDefault(require("../img/error.svg"));

var _warning = _interopRequireDefault(require("../img/warning.svg"));

var _info = _interopRequireDefault(require("../img/info.svg"));

var _close = _interopRequireDefault(require("../img/close.svg"));

function _default(palette) {
  return {
    duration: palette.transitionDuration,
    timingFunction: palette.transitionFunction,
    paddingTop: "".concat(palette.gutter, "px"),
    paddingRight: "".concat(palette.gutter * 2, "px"),
    paddingBottom: "".concat(palette.gutter, "px"),
    paddingLeft: "".concat(palette.gutter * 2, "px"),
    borderRadius: "".concat(palette.gutter / 2, "px"),
    width: "".concat(palette.gutter * 45, "px"),
    maxWidth: "".concat(palette.gutter * 45, "px"),
    fontSize: palette.tsSmall,
    lineHeight: palette.tlSmall,
    boxShadow: "0 8px 12px 0 ".concat(palette.elShadow, ", 0 6px 12px 0 ").concat(palette.elShadow),
    animationShow: null,
    animationHide: null,
    closeIconTop: "".concat(palette.gutter, "px"),
    closeIconRight: "".concat(palette.gutter, "px"),
    closeIcon: _close["default"],
    iconWidth: "".concat(palette.gutter * 3, "px"),
    iconHeight: "".concat(palette.gutter * 3, "px"),
    background: palette.elBlack,
    icon: "url(".concat(_info["default"], ")"),
    color: palette.tInversion,
    backgroundPrimary: palette.elAccent,
    iconPrimary: "url(".concat(_primary["default"], ")"),
    backgroundWarning: palette.elWarning,
    iconWarning: "url(".concat(_warning["default"], ")"),
    backgroundError: palette.elError,
    iconError: "url(".concat(_error["default"], ")")
  };
}